import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PenLine } from 'lucide-react';
import BookingPopup from '../BookingPopup';
import BlogSiteFooter from './BlogSiteFooter';
import Logo from '../../assets/logo.webp';

const BlogLayout = ({ children }) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 font-lato flex flex-col">
      {/* Always-white header — appropriate for content pages */}
      <header className="fixed w-full top-0 z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <Link to="/" className="flex items-center space-x-3 flex-shrink-0">
              <img
                src={Logo}
                alt="Nirvana Career Counselling"
                className="h-10 lg:h-12 object-contain"
              />
              <span className="hidden sm:block font-semibold text-teal-700 text-base lg:text-lg leading-tight">
                Nirvana Career<br className="hidden lg:block" /> Counselling
              </span>
            </Link>

            <div className="flex items-center space-x-4">
              <Link
                to="/blog"
                className="hidden md:flex items-center space-x-1 text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium"
              >
                <PenLine className="h-4 w-4" />
                <span>Blog</span>
              </Link>
              <button
                onClick={() => setIsBookingOpen(true)}
                className="px-4 py-2 bg-teal-600 text-white text-sm font-bold rounded-md hover:bg-yellow-500 hover:text-black transition-all"
              >
                Book Free Session
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main content — pt accounts for fixed header */}
      <main className="flex-1 pt-16 lg:pt-20">
        {React.cloneElement(children, { onBookingOpen: () => setIsBookingOpen(true) })}
      </main>

      <BlogSiteFooter />

      {isBookingOpen && <BookingPopup onClose={() => setIsBookingOpen(false)} />}
    </div>
  );
};

export default BlogLayout;
